/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-documents
 * crm-screener-documents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerGeneratedDocument } from './ScreenerGeneratedDocument';
import {
    ScreenerGeneratedDocumentFromJSON,
    ScreenerGeneratedDocumentFromJSONTyped,
    ScreenerGeneratedDocumentToJSON,
} from './ScreenerGeneratedDocument';

/**
 * 
 * @export
 * @interface EnqueueGenerateReport200Response
 */
export interface EnqueueGenerateReport200Response {
    /**
     * 
     * @type {ScreenerGeneratedDocument}
     * @memberof EnqueueGenerateReport200Response
     */
    data?: ScreenerGeneratedDocument;
}

/**
 * Check if a given object implements the EnqueueGenerateReport200Response interface.
 */
export function instanceOfEnqueueGenerateReport200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EnqueueGenerateReport200ResponseFromJSON(json: any): EnqueueGenerateReport200Response {
    return EnqueueGenerateReport200ResponseFromJSONTyped(json, false);
}

export function EnqueueGenerateReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnqueueGenerateReport200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ScreenerGeneratedDocumentFromJSON(json['data']),
    };
}

export function EnqueueGenerateReport200ResponseToJSON(value?: EnqueueGenerateReport200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ScreenerGeneratedDocumentToJSON(value.data),
    };
}

